import { createReducer } from 'reduxsauce';

export const INITIAL_STATE = {
  checkInvitation: { data: {} },
  acceptInvitation: { data: {} },
};

export default createReducer(INITIAL_STATE, {});
